<mat-tab-group disableRipple animationDuration="500ms">
  <!-- Sede Paraiso -->
  <mat-tab [label]="sede.title" *ngFor="let sede of sedes" class="tab-institucional">
    <ng-template matTabContent>
      <div class="content-banner d-flex flex-row">
        <div class="content-banner-information">
          <ul class="list-unstyled">
            <label-block-date [info]="sede"></label-block-date>
          </ul>
        </div>

        <img class="img-banner" [src]="sede.imagen" alt="img-information" />
      </div>
      <div class="content-banner2 inline-html" [innerHtml]="sede.html"></div>
    </ng-template>
  </mat-tab>
</mat-tab-group>